import { render } from "./RequiredText.vue?vue&type=template&id=2c9af954&scoped=true"
import script from "./RequiredText.vue?vue&type=script&lang=js"
export * from "./RequiredText.vue?vue&type=script&lang=js"

import "./RequiredText.vue?vue&type=style&index=0&id=2c9af954&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9af954"]])

export default __exports__